var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/global/window.js
// module id = 980
// module chunks = 0 1 2 3 4 5 6 7 8